import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { reportAPI } from '../services/api';
import ReportViewer, { ReportCards } from '../components/ReportViewer';

export default function ReportsSection({ title = 'Reports', subtitle = 'Generate and export reports' }) {
  const [reportData, setReportData] = useState(null);
  const [activeReport, setActiveReport] = useState(null);
  const [generating, setGenerating] = useState(false);

  const generateReport = async (type) => {
    setGenerating(true);
    setActiveReport(type);
    try {
      const response = await reportAPI.getDashboard();
      setReportData(response.data || response);
    } catch (error) {
      toast.error('Failed to load report data');
    } finally {
      setGenerating(false);
    }
  };

  const handleBack = () => {
    setActiveReport(null);
    setReportData(null);
  };

  if (activeReport) {
    return (
      <ReportViewer
        reportData={reportData}
        activeReport={activeReport}
        onBack={handleBack}
        generating={generating}
      />
    );
  }

  return (
    <div className="main-content">
      <div className="page-header">
        <div>
          <h1 className="page-title">{title}</h1>
          <p className="page-subtitle">{subtitle}</p>
        </div>
      </div>
      <ReportCards onGenerate={generateReport} />
    </div>
  );
}
